import { render, staticRenderFns } from "./cardetail.vue?vue&type=template&id=1772d3e0&scoped=true"
import script from "./cardetail.vue?vue&type=script&lang=js"
export * from "./cardetail.vue?vue&type=script&lang=js"
import style0 from "./cardetail.vue?vue&type=style&index=0&id=1772d3e0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1772d3e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1772d3e0')) {
      api.createRecord('1772d3e0', component.options)
    } else {
      api.reload('1772d3e0', component.options)
    }
    module.hot.accept("./cardetail.vue?vue&type=template&id=1772d3e0&scoped=true", function () {
      api.rerender('1772d3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/cardetail.vue"
export default component.exports